// export * from "./design";
export * from "./studies";
export * from "./run";
export * from "./auth";
export * from "./tags";
export * from "./home";
export * from "./assets";

// catch-all
export const FallbackRoute = {
	path: "*",
	redirect: "/home"
};
